import AbstractService from "./Abstract.service";

export default class SettingService extends AbstractService
{
    get_system_status(): Promise<any>
    {
        return this.post(`/control/get/ma`);
    }

    system_maintenance(payload:Object): Promise<any>
    {
        return this.post(`/control/maintenance`,payload);
    }

    change(payload:Object): Promise<any>
    {
        return this.post(`/admin/changePassword`,payload);
    }
}